import React, { useState, useContext, useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import Icon from '../atoms/Icon';
import ProgressBar from '../atoms/ProgressBar';
import { StateController } from './../../App';
import Preloader from '../atoms/Preloader';
import { getPrice, getProgressPercentPerBlock } from '../../utils/functions';
import Button from '../atoms/Button';
import FeedbackBlock from '../molecules/FeedbackBlock';
import MechanicModal from '../molecules/MechanicModal';
import TableRanking from '../molecules/TableRanking';
import Slider from 'react-slick';
import CounterDown from '../atoms/CounterDown'
import { sendDataLayer } from '../../utils/functions'
import useWidth from '../../hooks/useWidth'


function Progress() {
  // Tabs
  const sliderRef = useRef(null)
  const [activeTab, setActiveTab] = useState('prizes'); // 'progress' | 'prizes'

  // Estado original tuyo
  const [showAct] = useState(false);
  const [showMisiones] = useState(true);
  const [winner1, setWinner1] = useState(false); 
  const [showCounterDown, setShowCounterDown] = useState(false)
  const [superMarket, setsuperMarket] = useState(null);
  const [segment, setSegment] = useState(null);
  const [startAcelerator, setStartAcelerator] = useState(0);
  const [showTableRaking] = useState(true);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [requiredLogin] = useState(false);
  const { width } = useWidth();

  console.log("isFirstSlide", isFirstSlide)
  console.log("isLastSlide", isLastSlide)

  const dataRanking = [
    { id: '1', name: 'Gabino Zambrano', price: 'Renault Kwid 2026'},
    { id: '2', name: 'Adriana Pedraza', price: 'Moto Hero Xpulse 200 4V' },
    { id: '3', name: 'Miltón César Combariza', price: 'Kit Apple Lover (iPhone, Apple Watch y AirPods)' },
    { id: '4', name: 'Nidia Carmenza Acuña L.', price: 'Bono de viaje Éxito $5.000.000' },
    { id: '5', name: 'César Omar Duarte Mora', price: 'Bono Éxito $5.000.000' },
    { id: '6', name: 'Hugo Molina Gómez', price: 'Bono Éxito $150.000' },
    { id: '7', name: 'Andrés Felipe Garzón Brínez', price: 'Bono Éxito $150.000' },
    { id: '8', name: 'Gloria Cecilia Correa Quintero', price: 'Bono Éxito $150.000' },
    { id: '9', name: 'Óscar Fernando Aldana Beltrán', price: 'Bono Éxito $150.000' },
    { id: '10', name: 'Adriano Lobo Álvarez', price: 'Bono Éxito $150.000' },
    { id: '11', name: 'Patricia Elena Gaviria Escobar', price: 'Bono Éxito $150.000' },
    { id: '12', name: 'Paola Andrea Rosero Pascuaza', price: 'Bono Éxito $150.000' },
    { id: '13', name: 'Gabriel Peña Cano', price: 'Bono Éxito $150.000' },
    { id: '14', name: 'Juan Alberto Montes', price: 'Bono Éxito $150.000' },
    { id: '15', name: 'Jorge Humberto Calderón Giraldo', price: 'Bono Éxito $150.000' },
    { id: '16', name: 'Maritza Esther Simanca Noriega', price: 'Bono Éxito $150.000' },
    { id: '17', name: 'Zulma Esperanza Caro Ballesteros', price: 'Bono Éxito $150.000' },
    { id: '18', name: 'Diego José Mendoza Ramos', price: 'Bono Éxito $150.000' },
    { id: '19', name: 'Sergio Luis Villanueva Suárez', price: 'Bono Éxito $150.000' },
    { id: '20', name: 'Laura Stephania Gutiérrez Mosquera', price: 'Bono Éxito $150.000' },
    { id: '21', name: 'Gustavo de Jesús Zapata Osorio', price: 'Bono Éxito $150.000' },
    { id: '22', name: 'Andrés Felipe Tamayo Gómez', price: 'Bono Éxito $150.000' },
    { id: '23', name: 'Yenny Lucey Gómez Garzón', price: 'Bono Éxito $150.000' },
    { id: '24', name: 'María del Rosario de Ortega Samper', price: 'Bono Éxito $150.000' },
    { id: '25', name: 'Beatriz Inés Uribe Berrocal', price: 'Bono Éxito $150.000' },
    { id: '26', name: 'Johanna Alexandra Pérez Rincón', price: 'Bono Éxito $150.000' },
    { id: '27', name: 'Héctor Danovis Ríos Barrera', price: 'Bono Éxito $150.000' },
    { id: '28', name: 'Luz Amparo Romero Pulido', price: 'Bono Éxito $150.000' },
    { id: '29', name: 'Diana Marcela Galindo', price: 'Bono Éxito $150.000' },
    { id: '30', name: 'Lucía del Car Vásquez Pulgarín', price: 'Bono Éxito $150.000' },
    { id: '31', name: 'Luz Adriana Acuña Mejía', price: 'Bono Éxito $150.000' },
    { id: '32', name: 'Neifis Isabel Araujo Lúquez', price: 'Bono Éxito $150.000' },
    { id: '33', name: 'Sandra Patricia Vásquez Hernández', price: 'Bono Éxito $150.000' },
    { id: '34', name: 'Alejandra María Garcés Jaramillo', price: 'Bono Éxito $150.000' },
    { id: '35', name: 'Juan Esteban Ospina Ospina', price: 'Bono Éxito $150.000' },
    { id: '36', name: 'Armira Díaz de Reyes', price: 'Bono Éxito $150.000' },
    { id: '37', name: 'Angélica María Mujica Ospina', price: 'Bono Éxito $150.000' },
    { id: '38', name: 'María Encarnación Zuluaga Castrillón', price: 'Bono Éxito $150.000' },
    { id: '39', name: 'Anyicse Yulier Cumber Campos', price: 'Bono Éxito $150.000' },
    { id: '40', name: 'Rodrigo Bedoya Garzón', price: 'Bono Éxito $150.000' },
    { id: '41', name: 'Carlos Ariel Arroyave Duque', price: 'Bono Éxito $150.000' },
    { id: '42', name: 'Neguib Aníbal Rodríguez Montiel', price: 'Bono Éxito $150.000' },
    { id: '43', name: 'Juan Carlos Hoyos Botero', price: 'Bono Éxito $150.000' },
    { id: '44', name: 'Beatriz Méndez de Giraldo', price: 'Bono Éxito $150.000' },
    { id: '45', name: 'Juan Felipe Perdomo Ramírez', price: 'Bono Éxito $150.000' },
    { id: '46', name: 'Javier Alexander Aguiar Fonseca', price: 'Bono Éxito $150.000' },
    { id: '47', name: 'Mario Alexander García Giraldo', price: 'Bono Éxito $150.000' },
    { id: '48', name: 'Daniela Murillo Briceño', price: 'Bono Éxito $150.000' },
    { id: '49', name: 'Yuli Rocío Imbachi Pupiales', price: 'Bono Éxito $150.000' },
    { id: '50', name: 'Delis Esther Medina Jaramillo', price: 'Bono Éxito $150.000' },
    { id: '51', name: 'Juan Manuel Dangond Echavarría', price: 'Bono Éxito $150.000' },
    { id: '52', name: 'Ana Isabel Grisales Cardona', price: 'Bono Éxito $150.000' },
    { id: '53', name: 'Laura Lisseth Hernández Herrera', price: 'Bono Éxito $150.000' },
    { id: '54', name: 'Carlos Arturo González Villa', price: 'Bono Éxito $150.000' },
    { id: '55', name: 'Yonathan Bedoya Camargo', price: 'Bono Éxito $150.000' },
    { id: '56', name: 'José David Lasso Ospina', price: 'Bono Éxito $150.000' },
    { id: '57', name: 'William Domínguez', price: 'Bono Éxito $150.000' },
    { id: '58', name: 'Alexandra Patricia Páez Laserna', price: 'Bono Éxito $150.000' },
    { id: '59', name: 'David Felipe Olaya Jiménez', price: 'Bono Éxito $150.000' },
    { id: '60', name: 'Ángela Yurley Gaviria Rojas', price: 'Bono Éxito $150.000' },
    { id: '61', name: 'Luisa María Zapata Gallego', price: 'Bono Éxito $150.000' },
    { id: '62', name: 'Juan Camilo Restrepo Zuluaga', price: 'Bono Éxito $150.000' },
    { id: '63', name: 'Nataly López Toro', price: 'Bono Éxito $150.000' },
    { id: '64', name: 'Sandra Milena Gómez Guarín', price: 'Bono Éxito $150.000' },
    { id: '65', name: 'Wladimir García Cerón', price: 'Bono Éxito $150.000' },
    { id: '66', name: 'Karen Margarita Peña Reyes', price: 'Bono Éxito $150.000' },
    { id: '67', name: 'Mirley Johana García Colorado', price: 'Bono Éxito $150.000' },
    { id: '68', name: 'Olga Jimena Pulgarín Marín', price: 'Bono Éxito $150.000' },
    { id: '69', name: 'Mario Andrés Serrano Urueña', price: 'Bono Éxito $150.000' },
    { id: '70', name: 'Christian Andrés Gutiérrez Quintero', price: 'Bono Éxito $150.000' },
  ]

  const list = [
    {
      id: 0,
      title: 'Primer lugar',
      desc: 'Tu próxima parada puede ser en tu nuevo carro! Estrena un <b>Renault Kwid.</b>',
      img: '../images/sli1.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 1,
      title: 'Segundo lugar',
      desc: 'Recorre la ciudad o aventúrate fuera de ella, estrena una moto <b>Hero Xpulse.<b> ',
      img: '../images/sli2.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 2,
      title: 'Tercer lugar',
      desc: '<b>Llévate un kit Apple Lover:</b> iPhone 16e 128GB Black, AirPods (4ta Gen) con Case de Carga USB-C, Apple Watch SE 3(GPS) 44mm -Medianoche - Correa Deportiva Medianoche (M/L).',
      img: '../images/sli3.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 3,
      title: 'Cuarto lugar',
      desc: '<b>Disfruta un bono de viaje Éxito por $5 millones</b> para vivir la aventura que tú elijas.',
      img: '../images/sli4.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 4,
      title: 'Quinto lugar',
      desc: '<b>Gana un bono Éxito por $5 millones</b> y úsalo en lo que más te guste.',
      img: '../images/sli5.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 5,
      title: 'Sexto lugar en adelante',
      desc: '65 bonos Éxito, cargados con <b>$150.000.</b>',
      img: '../images/sli6.png',
      location: 'Sudáfrica',
      benefits: []
    }
  ]


  const CustomPrevArrow = ({ onClick }) => (
    <button
      onClick={() => {
        const currentSlide = sliderRef.current?.innerSlider?.state?.currentSlide || 0;

        sendDataLayer({ datalayer: { 
          event: 'carousel_navigation', 
          text: 'Descubre todo lo que puedes ganar',
          page_url: window.location.href,
          position: currentSlide.toString() }, repeat: true })
        if (onClick) {
          onClick();
        }

      }}
      className="custom-prev"
    ><img src="assets/images/left.png" alt="" /></button>
  );

  const CustomNextArrow = ({ onClick, disabled }) => (
    <button
      onClick={() => {
        if (disabled) return; // BLOQUEA EL CLICK

        const currentSlide = sliderRef.current?.innerSlider?.state?.currentSlide || 0;
        const currentSlideNext = currentSlide + 2;

        sendDataLayer({
          datalayer: {
            event: 'carousel_navigation',
            text: 'Descubre todo lo que puedes ganar',
            page_url: window.location.href,
            position: currentSlideNext.toString()
          },
          repeat: true
        });

        if (onClick) onClick();
      }}
      className={`custom-next ${disabled ? 'disabled' : ''}`}
      disabled={disabled}
    >
      <img src="assets/images/left.png" alt="" />
    </button>
  );

  const settings = {
    className: "center",
    // centerMode: true, 
    centerPadding: "0px",
    slidesToShow: 1,
    initialSlide: 0,
    speed: 500,
    variableWidth: true,
    focusOnSelect: true,
    dots: true,
    infinite: false,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    afterChange: (current) => {
      const total = list.length; // 🔥 usa TU DATA REAL
      setIsFirstSlide(current === 0);
      setIsLastSlide(current >= total - 1);
    },
    beforeChange: (_, next) => {
      const total = sliderRef.current?.innerSlider?.state?.slideCount || 0;
      setIsFirstSlide(next === 0);
      setIsLastSlide(next >= total - 1);
    },
    accessibility: false

  };

  useEffect(() => {
    const handleClick = (event) => {
      const element = event.target;
      const isSlickDot = element.closest('.slick-dots li');
      if (isSlickDot !== null) {
        sendDataLayer({ datalayer: { event: "carousel_navigation", text: "Gana asi", position: event.target.textContent, site_url: window.location.href }, repeat: true });
      } else {
        const btn = element.classList.contains('awards__btn') ? element : element.closest('.awards__btn');
        if (!btn) return;

        if (btn.classList.contains('awards__btn--next')) {
          sendDataLayer({
            datalayer: {
              event: "carousel_navigation",
              text: "Descubre todo lo que puedes ganar",
              position: 1,
              site_url: window.location.href
            },
            repeat: true
          });
        } else if (btn.classList.contains('awards__btn--prev')) {
          sendDataLayer({
            datalayer: {
              event: "carousel_navigation",
              text: "Descubre todo lo que puedes ganar",
              position: 0,
              site_url: window.location.href
            },
            repeat: true
          });
        }
      }
    };
    document.addEventListener('click', handleClick, true);
  }, []);


  let { context } = useContext(StateController);

  if (!requiredLogin && !context) {
    context = {
      user: { segment: 'exito' },
      tracing: {}
    }
  }

  useEffect(() => {
    const now = new Date();
    const startDate = new Date('2026-12-05T00:00:00');
    const endDate = new Date('2026-12-12T23:59:59');

    if (now >= startDate && now <= endDate && context) {
      setShowCounterDown(true);
    }
  }, [context])

  useEffect(() => {
    if (context?.user?.segment) {
      setsuperMarket(context.user.segment.toLowerCase());
      setSegment(context.user.segment.toLowerCase() == "exito" ? "Éxito" : "Carulla")
    }

    if (context?.tracing && context.tracing[`winner_1`] === 1) {
      setWinner1(true);
    }

  }, [context]);

  useEffect(() => {
    const now = new Date();
    const startDate1 = new Date('2026-04-20T00:00:00');
    const startDate1_2 = new Date('2026-05-01T00:00:00');
    const startDate2 = new Date('2026-05-02T00:00:00');
    const startDate3 = new Date('2026-05-11T00:00:00');
    const startDate4 = new Date('2026-06-09T00:00:00');
    const startDate5 = new Date('2026-06-16T00:00:00');

    if(now >= startDate1 && now <= startDate1_2) {
      setStartAcelerator(1);
    }else if(now >= startDate2 && now < startDate3){
      setStartAcelerator(2);
    }else if(now >= startDate3 && now < startDate4){
      setStartAcelerator(3);
    }else if(now >= startDate4 && now < startDate5){
      setStartAcelerator(4);
    }else if(now >= startDate5){
      setStartAcelerator(5);
    }
  }, []);

  console.log('startAcelerator', startAcelerator);

  useEffect(() => {
    const handleClick = (event) => {
      const element = event.target;
      
      const tab_btn = element.classList.contains('tab-btn') ? element : element.closest('.tab-btn');
      if (tab_btn) {
        sendDataLayer({datalayer: {
          event: 'menu',
          text: tab_btn.textContent,
        },repeat: true})
        return;
      }
      const btn = element.classList.contains('awards__btn') ? element : element.closest('.awards__btn');
      if (!btn) return;

      if (btn.classList.contains('awards__btn--next')) {
        sendDataLayer({
          datalayer: {
            event: "carousel_navigation",
            text: "Descubre todo lo que puedes ganar",
            position: 1,
            site_url: window.location.href
          },
          repeat: true
        });
      } else if (btn.classList.contains('awards__btn--prev')) {
        sendDataLayer({
          datalayer: {
            event: "carousel_navigation",
            text: "Descubre todo lo que puedes ganar",
            position: 0,
            site_url: window.location.href
          },
          repeat: true
        });
      }
    };
    document.addEventListener('click', handleClick, true);
  }, []);

  const setExplorerAward = () => {
    setActiveTab('prizes')
    sendDataLayer({datalayer: { event: 'progress', text: 'Explorar los premios'},repeat: true})
  };

  // Navegación con teclado entre tabs
  const onTabsKeyDown = useCallback((e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault();
    setActiveTab((prev) => (prev === 'progress' ? 'prizes' : 'progress'));
  }, []);

  const formatearFecha = (fecha) => {
    const [anio, mes, dia] = fecha.split('-');
    return `${dia}/${mes}/${anio}`;
  };

  const safeDate = context?.tracing?.date_update ? formatearFecha(context.tracing.date_update) : '15/04/2026';

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Función para abrir el modal
  const openModal = () => {
    sendDataLayer({datalayer: { event: 'progress', text: '¿Cómo ganar?'},repeat: true})
    setIsModalOpen(true);
  }

  useEffect(() => {
    if (!requiredLogin) {
      context = context || {};
      context.user = context.user || {};
      context.user.segment = "exito";

      setsuperMarket(context.user.segment.toLowerCase() == "exito" ? "Éxito" : "Carulla")
      setSegment(context.user.segment.toLowerCase() == "exito" ? "Éxito" : "Carulla")
    }
  
    console.log('contexts', context);
    console.log('ontabskeydown', onTabsKeyDown);
  }, []);

  return (
    <>
      {!context && requiredLogin ? (
        <Preloader type='fullscreen' invert />
      ) :


        <div className={`mc-page progress slow_anito ${superMarket !== "exito" ? "carulla" : "exito"}`}>
          {showCounterDown && 
            <CounterDown comercio={superMarket !== "exito" ? "Carulla" : "Éxito"}/>
          }
          {/* Header de Tabs */}
          {/* HERO + TABS */}
          <section className={`hero hero--${activeTab}`}>
            {/* Tabs */}
            {/*<div
              className="tabs-header"
              role="tablist"
              aria-label="Meta y progreso / Premios"
              onKeyDown={onTabsKeyDown}
            >
              <button
                role="tab"
                id="tab-progress"
                aria-controls="panel-progress"
                aria-selected={activeTab === 'progress'}
                tabIndex={activeTab === 'progress' ? 0 : -1}
                className={`tab-btn ${activeTab === 'progress' ? 'is-active' : ''}`}
                onClick={() => setActiveTab('progress')}
                type="button"
              >
                <span className="tab-icon" aria-hidden><img className='logotab' src="/assets/images/meta.png" alt="" /></span>
                Meta y progreso
              </button>

              <button
                role="tab"
                id="tab-prizes"
                aria-controls="panel-prizes"
                aria-selected={activeTab === 'prizes'}
                tabIndex={activeTab === 'prizes' ? 0 : -1}
                className={`tab-btn ${activeTab === 'prizes' ? 'is-active' : ''}`}
                onClick={() => setActiveTab('prizes')}
                type="button"
              >
                <span className="tab-icon" aria-hidden><img className='logotab' src="/assets/images/trophy.png" alt="" /></span>
                Ganadores
              </button>
            </div>*/}

            {/* Copy dentro del hero (cambia según tab) */}
            {activeTab === 'progress' && requiredLogin ? (
              <div className="hero__content">
                <div className="max-content">
                  <h1 className="hero__title">Meta y progreso</h1>
                  <p className="hero__subtitle">
                    <strong>Revisa tu avance:</strong> tus compras están ayudando a
                    cumplir tu meta.
                  </p>

                  {/* CTA naranja como en el mock */}
                  <div className="hero__cta">
                    {/* Si prefieres usar tu átomo Button */}
                    <Button
                      type="primary"
                      text="¿Cómo ganar?"
                      status="active"
                      onClick={openModal} // Cambiar de setActiveTab a openModal para abrir el modal
                      datalayer={{ event: 'hero', text: '¿Cómo ganar?' }}
                    />

                    {/* Modal que se abrirá cuando el estado isModalOpen sea true */}

                    {/* Alternativa simple:
        <a className="btn-orange" href="#como-ganar">¿Cómo ganar?</a>
        */}
                  </div>
                </div>
              </div>
            ) : (
              <>
              <div className="hero__content">
                <div className="max-content">
                  <h1 className="hero__title">Ganadores</h1>
                  <p className="hero__subtitle">
                    <strong>¡La campaña finalizó!</strong>
                    <br />
                    {width > 1230 ? "Descubre las posiciones de los ganadores." : <>Descubre las posiciones de los<br/> ganadores.</> }
                  </p>
                </div>
                {/* En Premios no hay botón en el mock, así que lo omitimos */}
              </div>
              
              {showTableRaking &&
                <TableRanking
                  data={dataRanking}
                  segment={context.user.segment.toLowerCase() == "exito" ? "exito" : "carulla"}
                />
              }
                
              </>
            )}
          </section>


          {/* Contenido */}
          {!context ? (
            <Preloader type='section-red' invert />
          ) : (
            <>
              <div className={`progress-container ${(showMisiones || showAct) ? 'active' : ''}`}>

                {/* PANEL 1: Meta y progreso */}
                <section
                  role='tabpanel'
                  id='panel-progress'
                  aria-labelledby='tab-progress'
                  hidden={activeTab !== 'progress'}
                  className={`panel panel-progress ${activeTab === 'progress' ? 'is-visible' : ''}`}
                >
                  <div className='misiones-status-container'>
                    <div className='misiones-container'>

                      {/* Barra de alerta */}
                      {/* <div className='misiones-alert-bar'>
                        <img src={`/assets/images/Alert_icon.png`} alt='' />
                        {context.tracing && context.tracing.date_update ? (
                          <span className='misiones-alert-text'>
                            Su progreso incluye las compras realizadas hasta el
                            <strong className='info-alert'> {safeDate} </strong>
                            y se actualiza semanalmente.
                          </span>
                        ) : (
                          <span className='misiones-alert-text'>
                            Las compras realizadas a partir del 08/10/2025 se verán reflejadas desde 22/10/2025
                          </span>
                        )}
                      </div> */}

                      {showMisiones && (
                        <div className='misiones-desc'>

                          {context && (
                            <div className='despegue-container'>


                              <div className='barInfo-container'>
                                {/* Compras en Éxito */}
                                <h3 className={`section-caption`}>Conoce tu progreso</h3>
                                <p>Sigue de cerca tus metas <b>en {context.user.segment.toLowerCase() == "exito" ? "Éxito" : "Carulla"} y en otros comercios.</b></p>                                <div className="los2">
                                  <div className='barInfo'>
                                    <div className='barInfo--head'>
                                      <Icon name='shop' /> Compras* en {context.user.segment.toLowerCase() == "exito" ? "Éxito" : "Carulla"}
                                    </div>
                                    <div className='barInfo--row'>
                                      <span>
                                        <strong>Llevas:</strong> {getPrice(context.tracing ? context.tracing[`amount_1`] : 0)}
                                      </span>
                                      <span>
                                        <strong>Meta:</strong> {getPrice(context.user ? context.user[`goal_amount_1`] : 0)}
                                      </span>
                                    </div>
                                    <ProgressBar
                                      percent={getProgressPercentPerBlock(context, 'amount', 1)}
                                      label={`${getProgressPercentPerBlock(context, 'amount', 1)}%`}
                                      icon='/assets/images/icono progreso.png'
                                    />
                                  </div>

                                  {/* Compras en otros comercios */}
                                  <div className='barInfo'>
                                    <div className='barInfo--head'>
                                      <Icon name='shop' /> Compras en otros comercios
                                    </div>
                                    <div className='barInfo--row'>
                                      <span>
                                        <strong>Llevas:</strong> {getPrice(context.tracing ? context.tracing[`amount_2`] : 0)}
                                      </span>
                                      <span>
                                        <strong>Meta:</strong> {getPrice(context.user ? context.user[`goal_amount_2`] : 0)}
                                      </span>
                                    </div>
                                    <ProgressBar
                                      percent={getProgressPercentPerBlock(context, 'amount', 2)}
                                      label={`${getProgressPercentPerBlock(context, 'amount', 2)}%`}
                                      icon='/assets/images/icono progreso (1).png'
                                    />
                                  </div>
                                </div>

                                <p className='max-other'
                                  dangerouslySetInnerHTML={{
                                    __html: `Hoy se reflejan las compras que realizaste hasta el ${safeDate}. Ten en cuenta que la información se actualiza cada diez días hábiles.`,
                                  }}
                                />

                                <p className='max-other'
                                  dangerouslySetInnerHTML={{
                                    __html: `*La meta de compras en ${segment} <b>aplica para compras realizadas en los almacenes del Grupo Éxito</b> <br/> (incluye Éxito y Carulla).`,
                                  }}
                                />

                              </div>
                              <div className='barInfo-container'>
                                <h3 className={`section-caption second-caption`}>Impulsa tu progreso <br className='solo-mob' /> con los aceleradores</h3>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: `Aprovecha los aceleradores comprando en otros comercios <b>fuera ${context.user.segment.toLowerCase() == "exito" ? "del Grupo Éxito" : "de Carulla"}</b>, para avanzar más rápido y aumentar tus oportunidades de ganar. Hazlo tantas veces como quieras.`,
                                  }}
                                />
                                <div className="los1 los2">
                                  {/* Reto x1 */}
                                  <div className="challengeWrap">
                                    <div className="challengeWrapTitle">
                                      <span><b>Primer acelerador</b></span><div className={`challengeTag 
                                      ${context.tracing && context.tracing['progress_challenge_1'] >= 1 ? "challengeTag--win"  : 
                                        context.user.segment.toLowerCase() !== "exito" ? "challengeTag--muted challengeTag--muted__exp" : ""}
                                        `}>{context.tracing && context.tracing['progress_challenge_1'] >= 1 ? "Cumplido" : "Por cumplir"}</div>
                                    </div>

                                    <div className={`challengeCard challengeCard--x2`}>
                                      <div className="challengeCard__head">
                                        <div className="challengeCard__badge">x2</div>
                                        <h3 className="challengeCard__title">
                                          Tus suscripciones <br/>cuentan el doble.
                                        </h3>
                                      </div>

                                      <div className="challengeCard__body">
                                        <div className="challengeCard__equation" aria-label="Condiciones del reto">
                                          <div className="eq-line">Realiza un pago recurrente* en plataformas de streaming, transporte o domicilios.</div>
                                          <div className="eq-result">= Vale <strong>x2</strong></div>
                                        </div>

                                        <div className="challengeCard__status">
                                          <span className="status-icon" aria-hidden="true"><img src={`${context.tracing && context.tracing['progress_challenge_1'] >= 1 ? context.user.segment.toLowerCase() == "exito" ? "/assets/images/verified1.png" : "/assets/images/verified.png" : "/assets/images/gpp_maybe.png"}`} alt="" /></span>
                                          {`${context.tracing && context.tracing['progress_challenge_1'] >= 1 ? "Reto cumplido" : "Reto pendiente"}`} <strong>{context.tracing ? context.tracing['progress_challenge_1'] : 0}</strong> veces
                                        </div>
                                      </div>
                                    </div>
                                  </div>


                                  {/* Reto x2 */}
                                  <div className="challengeWrap">
                                    <div className="challengeWrapTitle">
                                      <span><b>Segundo acelerador</b></span><div className={`challengeTag 
                                        ${context.tracing && context.tracing['progress_challenge_2'] >= 1 ? "challengeTag--win" : 
                                          context.user.segment.toLowerCase() !== "exito" ? "challengeTag--muted challengeTag--muted__exp" : ""}
                                        `}>{context.tracing && context.tracing['progress_challenge_2'] >= 1 ? "Cumplido" : "Por cumplir"}</div>
                                    </div>
                                    <div className={`challengeCard challengeCard--x2`} aria-disabled="true">
                                      <div className="challengeCard__head">
                                        <div className="challengeCard__badge"><img className='cata_meat' src="/assets/images/meat.svg" alt="" /></div>
                                        <h3 className="challengeCard__title">
                                          Suma más en restaurantes y bares.
                                        </h3>
                                      </div>

                                      <div className="challengeCard__body">
                                        <div className="challengeCard__equation" aria-label="Condiciones del reto">
                                          <div className="eq-line">Paga en restaurantes y bares los viernes.</div>
                                          <div className="eq-result"><strong className="card2_result">= Vale 10% extra a tu meta.</strong></div>
                                        </div>

                                        <div className="challengeCard__status">
                                          <span className="status-icon" aria-hidden="true"><img src={`${context.tracing && context.tracing['progress_challenge_2'] >= 1 ? context.user.segment.toLowerCase() == "exito" ? "/assets/images/verified1.png" : "/assets/images/verified.png" : "/assets/images/gpp_maybe.png"}`} alt="" /></span>
                                          {`${context.tracing && context.tracing['progress_challenge_2'] >= 1 ? "Reto cumplido" : "Reto pendiente"}`} <strong>{context.tracing ? context.tracing['progress_challenge_2'] : 0}</strong> veces
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                                <div className="challengeWrap__middleText">
                                  <p><b>¡Acelerador especial!</b> Muy pronto llegarán aceleradores por tiempo limitado</p>
                                </div>

                                <div className="los2">
                                  {/* Reto x3 */}
                                  <div className="challengeWrap">
                                    <div className="challengeWrapTitle">
                                      <span className={startAcelerator !== 4 ? "challengeWrapTitle--disabled" : ""}><b>Tercer acelerador</b></span>
                                      {startAcelerator >= 1 &&
                                        <div className={`challengeTag ${
                                          startAcelerator === 4
                                            ? (context.tracing && context.tracing['progress_challenge_3'] == 1 ? "challengeTag--win" : "challengeTag--muted__exp")
                                            : "challengeTag--muted"
                                        }`}>
                                          {startAcelerator === 4
                                            ? (context.tracing && context.tracing['progress_challenge_3'] == 1 ? "Cumplido" : "Por cumplir")
                                            : (context.tracing && context.tracing['progress_challenge_3'] == 1 ? "Cumplido" : "Expiró")
                                          }
                                        </div>
                                      }
                                    </div>
                                    <div className={`challengeCard challengeCard--x2 ${startAcelerator === 4 ? "" : "challengeCard--disabled"}`}>
                                      <div className="challengeCard__head">
                                        <div className="challengeCard__badge"><img className='cata_meat' src={startAcelerator === 4 ? "/assets/images/black_airplane.svg" : "/assets/images/airplane.svg" } alt="" /></div>
                                        <h3 className="challengeCard__title">
                                          Viaja y suma más.
                                        </h3>
                                      </div>

                                      <div className="challengeCard__body">
                                        <div className="challengeCard__equation" aria-label="Condiciones del reto">
                                          <div className="eq-line"><strong>Del 9 al 15 de junio de 2026</strong>Reserva en aerolíneas, hoteles o agencias de viaje</div>
                                          <div className="eq-result">= <strong className="card2_result">Vale 50% extra a tu meta.</strong></div>
                                        </div>

                                        <div className="challengeCard__status">
                                          <span className="status-icon" aria-hidden="true"><img src={`${context.tracing && context.tracing['progress_challenge_3'] >= 1 ? context.user.segment.toLowerCase() == "exito" ? "/assets/images/verified1.png" : "/assets/images/verified.png" : "/assets/images/gpp_maybe.png"}`} alt="" /></span>
                                          {`${context.tracing && context.tracing['progress_challenge_3'] >= 1 ? "Reto cumplido" : "Reto pendiente"}`} <strong>{context.tracing ? context.tracing['progress_challenge_3'] : 0}</strong> veces
                                        </div>
                                      </div>
                                    </div>
                                  </div>


                                  {/* Reto x4 */}
                                  <div className="challengeWrap">
                                    <div className="challengeWrapTitle">
                                      <span className={startAcelerator < 2 ? "challengeWrapTitle--disabled" : ""}><b>Cuarto acelerador</b></span>
                                      {startAcelerator >= 2 &&
                                        <div className={`challengeTag ${
                                          startAcelerator === 2
                                            ? (context.tracing && context.tracing['progress_challenge_4'] == 1 ? "challengeTag--win" : "challengeTag--muted__exp")
                                            : "challengeTag--muted"
                                        }`}>
                                          {startAcelerator === 2
                                            ? (context.tracing && context.tracing['progress_challenge_4'] == 1 ? "Cumplido" : "Por cumplir")
                                            : (context.tracing && context.tracing['progress_challenge_4'] == 1 ? "Cumplido" : "Expiró")
                                          }
                                        </div>
                                      }
                                    </div>
                                    <div className={`challengeCard challengeCard--x2 ${startAcelerator === 2 ? "" : "challengeCard--disabled"}`} aria-disabled="true">
                                      <div className="challengeCard__head">
                                        <div className="challengeCard__badge"><img className='cata_meat' src={startAcelerator === 2 ? "/assets/images/black_shirt.svg" : "/assets/images/shirt.svg" } /></div>
                                        <h3 className="challengeCard__title">
                                          Sorprende a mamá: tus compras de moda suman el doble.
                                        </h3>
                                      </div>

                                      <div className="challengeCard__body">
                                        <div className="challengeCard__equation" aria-label="Condiciones del reto">
                                          <div className="eq-line"><strong>Del 2 al 10 de mayo de 2026</strong>Hacer 1 compra en moda</div>
                                          <div className="eq-result"><strong>= Vale x2</strong></div>
                                        </div>

                                        <div className="challengeCard__status">
                                          <span className="status-icon" aria-hidden="true"><img src={`${context.tracing && context.tracing['progress_challenge_4'] >= 1 ? context.user.segment.toLowerCase() == "exito" ? "/assets/images/verified1.png" : "/assets/images/verified.png" : "/assets/images/gpp_maybe.png"}`} alt="" /></span>
                                          {`${context.tracing && context.tracing['progress_challenge_4'] >= 1 ? "Reto cumplido" : "Reto pendiente"}`} <strong>{context.tracing ? context.tracing['progress_challenge_4'] : 0}</strong> veces
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: `*Las compras recurrentes incluyen pagos automáticos en plataformas de streaming y servicios digitales, además de compras en apps de transporte o domicilios. `,
                                  }}
                                />

                              </div>

                              {winner1 && context && context.block === 1 && (
                                <span className='extra-info-box'>
                                  {/* Redima su bono antes del <strong>30 de noviembre de 2025</strong> */}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </section>

                {/* PANEL 2: Premios (base para no romper tabs) */}
                <section
                  role='tabpanel'
                  id='panel-prizes'
                  aria-labelledby='tab-prizes'
                  hidden={activeTab !== 'prizes'}
                  className={`panel panel-prizes ${activeTab === 'prizes' ? 'is-visible' : ''}`}
                >
                  <section className="mc-login__majorAward">
                    <div className="awards__grid">
                      {/* ====== LADO IZQUIERDO (título + íconos + banner) ====== */}
                      <aside className="awards__intro">
                        <h2 className="h2" style={{ margin: 0 }}>
                          Los ganadores se llevaron:
                        </h2>
                          <p style={{ marginTop: 8, marginBottom: 14 }}>
                            Increíbles premios que hicieron parte de esta experiencia. ¡Pronto tendrás una nueva oportunidad de ganar!
                          </p>
                        <img className='cata solo-exito' src="/assets/images/icons2.png" alt="" />
                        <img className='cata solo-carulla' src="/assets/images/icons3.png" alt="" />
                        {/* Si usarás una sola imagen con los 4 íconos, deja solo este <img /> */}
                        {/* <img src="/assets/premios/iconos-strip.png" alt="Iconos premios" width="220" height="48" /> */}

                        {/* Si los manejas por separado, deja la UL */}
                        {/* <ul className="awards__icons" aria-label="Categorías de premios">
          <li><img src="/assets/premios/icon-car.svg" alt="Auto" width="42" height="42" /></li>
          <li><img src="/assets/premios/icon-moto.svg" alt="Moto" width="42" height="42" /></li>
          <li><img src="/assets/premios/icon-market.svg" alt="Mercado" width="42" height="42" /></li>
          <li><img src="/assets/premios/icon-card.svg" alt="Bonos" width="42" height="42" /></li>
        </ul> */}

                      </aside>

                      {/* ====== LADO DERECHO (slider vertical 2 columnas) ====== */}
                      <div className="awards__cardsPager">
                        <div className='bg-custom-alliances'>
                          <section className='SliderPlanSection slider-container-alliances'>
                            <article className={`main-slider ${isFirstSlide ? 'is-first-slide' : ''}`}>
                              <div className="slider-container-alliances_slider scroll-here">
                                <Slider ref={sliderRef} {...settings}>
                                  {list.map((item, i) => (
                                    <div className='card-planSlider' key={i}>
                                      <div className="banner">
                                        <img src={`/assets/mayor-award/${item.img}`} alt={item.title} />
                                      </div>
                                      <div className="card-content-plan-slider">
                                        <h4 dangerouslySetInnerHTML={{ __html: item.title }} />
                                        <h5>
                                          <div dangerouslySetInnerHTML={{ __html: item.desc }} />
                                        </h5>
          
                                        <ul>
                                          {item.benefits.map((benefit, i) => (
                                            <li key={i}>
                                              <span className={`icon-slider-plan`}><Icon name={benefit.icon} /></span>
                                              <p>{benefit.name}</p>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    </div>
                                  ))}
                                </Slider>
                              </div>
                            </article>
                          </section>
                        </div>
                      </div>
                    </div>
                  </section>
                </section>



              </div>
              <section className="discover" aria-labelledby="discover-title">
                <div className="discover__inner">
                  <figure className="discover__media">
                    <img
                      src="/assets/images/men_car.png"
                      alt="Pareja feliz conduciendo"
                      className="discover__img"
                      loading="lazy"
                    />
                  </figure>

                  <div className="discover__content">
                    <h3 id="discover-title" className="discover__title">Descubre los premios</h3>
                    <p className="discover__copy">
                     Podrás ganar desde un carro o una moto, hasta un kit Apple, un bono de viaje y bonos Éxito, solo por usar tu 
                     <strong> Tarjeta {segment} Mastercard</strong>.
                    </p>

                    {/* CTA naranja */}
                    <a onClick={() => setExplorerAward()} href='#root' className="discover__cta">Explorar los premios</a>
                    {/*
        Si prefieres cambiar de tab en la misma página y SÍ tienes setActiveTab:
        <button type="button" className="discover__cta" onClick={() => setActiveTab('prizes')}>
          Explorar los premios
        </button>
      */}
                  </div>
                </div>
              </section>

            </>
          )}

          <FeedbackBlock />
          
          <MechanicModal
            show={isModalOpen}
            setShowModal={setIsModalOpen}
            segment={segment} 
          />
        </div>
      }
    </>

  );
}

const mapState = ({ user: { token } }) => ({ token });
export default connect(mapState)(Progress);
